import { render, staticRenderFns } from "./EmployeeRegistrationModal.vue?vue&type=template&id=78054bac&scoped=true&"
import script from "./EmployeeRegistrationModal.vue?vue&type=script&lang=ts&"
export * from "./EmployeeRegistrationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78054bac",
  null
  
)

export default component.exports